import api from './client';

export const getFooterData = async () => {
  try {
    const res = await api.get('/footer');
    return res.data?.data || null;
  } catch (err) {
    console.error('Footer API error:', err);
    return null;
  }
};
